import { Component, OnInit } from '@angular/core';
import { PoBreadcrumb, PoNotificationService } from '@po-ui/ng-components';
import { HttpClient } from '@angular/common/http';
import { RpaService } from '../../../core/rpa/rpa.service';
import { EmpresaRpaDto } from '../../../models/Empresas/empresa-rpa-dto';
import { environment } from '../../../../environments/environment';
import { COMPETENCIA_RELATORIO_OPTIONS } from '../../rpas/rpa-relatorio-pendencias.config';

@Component({
  selector: 'app-certidoes-relatorio',
  templateUrl: './certidoes-relatorio.component.html',
  styleUrls: ['./certidoes-relatorio.component.css'],
  standalone: false
})
export class CertidoesRelatorioComponent implements OnInit {
  tipoCertidao = '';
  cidade = 'SANTO ANDRE';
  competencia = '';
  tipoFiltro = '0';
  cidadesOptions: Array<{ label: string; value: string }> = [];
  readonly competenciaOptions = COMPETENCIA_RELATORIO_OPTIONS;
  loading = false;
  readonly serviceApi = environment.apiUrl + '/v1/empresas';

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', link: '/home' },
      { label: 'Certidões', link: '/certidoes' },
      { label: 'Relatório' }
    ]
  };

  constructor(
    private readonly rpaService: RpaService,
    private readonly poNotificationService: PoNotificationService,
    private readonly http: HttpClient
  ) {}

  ngOnInit(): void {
    this.loadCidades();
  }

  onChangeTipocertidao(event: string): void {
    this.tipoCertidao = event;
  }

  onChangeCompetencia(event: string): void {
    this.competencia = event;
  }

  onChangeCidade(event: string): void {
    this.cidade = event;
  }

  geraReportEmpresaCertidao(): void {
    if (!this.tipoFiltro || this.tipoCertidao === '' || this.competencia === '') {
      this.poNotificationService.warning('Preencha todos os campos para gerar o relatório.');
      return;
    }

    this.loading = true;
    this.rpaService
      .requestEmpresasRpa(this.tipoCertidao, this.cidade, this.competencia, this.tipoFiltro, '0')
      .subscribe({
        next: (data) => {
          this.exportToCsv(data, 'empresas_certidoes');
          this.downloadArquivosLote(data);
        },
        error: () => {
          this.loading = false;
          this.poNotificationService.error('Erro ao gerar relatório de certidões.');
        }
      });
  }

  private loadCidades(): void {
    this.http.get<string[]>(`${this.serviceApi}/cidades`).subscribe({
      next: (cidades) => {
        this.cidadesOptions = cidades.map((cidade) => ({
          label: cidade,
          value: cidade
        }));
        if (this.cidadesOptions.find((c) => c.value === 'SANTO ANDRE')) {
          this.cidade = 'SANTO ANDRE';
        } else if (this.cidadesOptions.length > 0) {
          this.cidade = this.cidadesOptions[0].value;
        }
      },
      error: () => {
        this.poNotificationService.error('Erro ao carregar lista de cidades.');
      }
    });
  }

  private exportToCsv(data: EmpresaRpaDto[], fileName: string): void {
    if (data.length === 0) {
      this.poNotificationService.warning('Nenhum dado encontrado para exportação.');
      return;
    }

    const header = Object.keys(data[0] as object).join(';') + '\n';
    const rows = data.map((row) => Object.values(row as object).join(';')).join('\n');
    const blob = new Blob([header + rows], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${fileName}_${Date.now()}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  private downloadArquivosLote(data: EmpresaRpaDto[]): void {
    const objectNames = data
      .map((item) => item.rpaUrl || '')
      .filter((url) => url && url.trim() !== '');

    if (objectNames.length === 0) {
      this.poNotificationService.warning('CSV gerado. Nenhum arquivo encontrado para download.');
      this.loading = false;
      return;
    }

    const batches = this.chunkArray(objectNames, 100);
    this.processBatches(batches);
  }

  private chunkArray(array: string[], size: number): string[][] {
    return Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
      array.slice(i * size, i * size + size)
    );
  }

  private processBatches(batches: string[][]): void {
    this.loading = true;
    let indice = 0;

    const processarProximo = (): void => {
      if (indice >= batches.length) {
        this.loading = false;
        this.poNotificationService.success('Download concluído com sucesso!');
        return;
      }

      const lote = indice;
      this.rpaService.baixarZipLoteStream(batches[lote]).subscribe({
        next: (blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `certidoes_${new Date().toISOString()}-lote${lote + 1}.zip`;
          a.click();
          window.URL.revokeObjectURL(url);
          indice++;
          processarProximo();
        },
        error: () => {
          this.loading = false;
          this.poNotificationService.error(`Erro ao processar o lote ${lote + 1}.`);
        }
      });
    };

    processarProximo();
  }
}
